import type { SeparatorProps } from '@nuxt/ui'

const sectionSeparator: NonNullable<SeparatorProps['ui']> = {
  root: 'mb-8 lg:mb-10',
}

export { sectionSeparator }
